module.exports = __webpack_public_path__ + "static/4-92d1bcb3c5d09e3096c711a923ca31fc.jpg";